import React, { useContext } from "react";
import { Formik, Form } from "formik";
import { MdCheckCircle, MdOutlineModeEditOutline, MdPlace, MdCancel } from "react-icons/md";
import { BsCalendarPlus } from "react-icons/bs";
import { Col, Row } from "react-bootstrap";

import Select from "../../../shared/Select";
import TextArea from "../../../shared/TextArea";
import Checkbox from "../../../shared/Checkbox";
import SelectPcp from "../../forms/SelectPcp";
import SelectDate from "../../forms/SelectDate";
import SelectVisitType from "../../forms/SelectVisitType";
import Lead from "../../../shared/Lead";
import FieldError from "../../../shared/FieldError";

import { Task, Settings } from "../../../helpers/Contexts";

const Request = ({ appointment, formHandler }) => {
  const settings = useContext(Settings);
  const { taskValues, setTaskValues } = useContext(Task);
  return (
    <>
      <Formik
        initialValues={{
          notes: appointment.notes,
          procedure_type_id: appointment.procedure_type_id,
          procedure_type: appointment.procedure_type,
          pcp_practice_id: appointment.pcp_practice ? appointment.pcp_practice.id : "",
          pcp_practice_address: appointment.pcp_practice ? appointment.pcp_practice.address : "",
          pcp_practice_name: appointment.pcp_practice ? appointment.pcp_practice.name : "",
          pcp: appointment.pcp,
          pcp_id: appointment.pcp_id,
          date: appointment.request_date_end
            ? appointment.request_date_start + " to " + appointment.request_date_end
            : appointment.request_date_start,
          request_date_start: appointment.request_date_start,
          request_date_end: appointment.request_date_end,
          preferred_contact_method: appointment.preferred_contact_method
            ? appointment.preferred_contact_method
            : "",
          established: appointment.established,
          patient_booking_availability: appointment.patient_booking_availability,
          patient_availability_notes: appointment.patient_availability_notes,
          reason_for_visit: appointment.reason_for_visit,
          assignee_id: appointment.assignee_id,
          assignee: appointment.assignee.name && appointment.assignee.name,
          assignee_support_group_id:
            appointment.assignee_support_group_id && appointment.assignee_support_group_id,
        }}
        validateOnChange={true}
        onSubmit={(values) => {
          formHandler({
            task: {
              id: appointment.id,
              reason_for_visit: values.reason_for_visit,
              request_date_start: values.request_date_start,
              pcp_location_id: values.pcp_location_id,
              request_date_end: values.request_date_end,
              patient_availability_notes: values.patient_availability_notes,
              procedure_type_id: values.procedure_type_id,
              assignee_id: values.assignee_id,
              established: values.established,
              preferred_contact_method: values.preferred_contact_method,
              pcp_id: values.pcp_id && values.pcp_id,
              pcp_practice_id: values.pcp_practice_id,
              notes: values.notes,
              patient_booking_availability: values.patient_booking_availability,
              assigner_id: settings.me.id,
              assignee_support_group_id: values.assignee_support_group_id,
            },
          });
        }}
      >
        {({ values, setFieldValue, handleChange }) => {
          function renderEditRequestForm() {
            return (
              <Form className="task-form">
                <MdOutlineModeEditOutline id="pencil-icon" />
                <Lead message={"Editing " + "Appointment Request"} /> <br />
                <BsCalendarPlus id="appointment-big-icon" />
                <br />
                <br />
                <SelectVisitType
                  name="procedure_type"
                  value={values.procedure_type_id}
                  setFieldValue={setFieldValue}
                />
                <Row>
                  <Col md={6} id="field-left">
                    <label>{"Requested Provider"}</label>
                    {values.procedure_type == "Lab/Diagnostic Only" ? (
                      <select disabled className="dropdown-select">
                        <option value={""}>{"N/A for Lab/Diagnostic Only"}</option>
                      </select>
                    ) : (
                      <SelectPcp name="pcp" active={false} required={true} setFieldValue={setFieldValue} />
                    )}
                  </Col>

                  <Col md={6} id="field-right">
                    <Select
                      label="Patient Status"
                      name="established"
                      onChange={(e) => {
                        if (e.target.value == "true") {
                          setFieldValue("established", "true");
                        } else {
                          setFieldValue("established", "false");
                        }
                      }}
                    >
                      {values.established ? (
                        values.established
                      ) : (
                        <option value="">{"Select patient status with PCP Group"}</option>
                      )}
                      <option value={"false"}>{"New"}</option>
                      <option value={"true"}>{"Established"}</option>
                    </Select>
                    {!values.established && (
                      <>
                        <FieldError
                          error={
                            "Patient status is required. Select established if patient has been established with PCP Group."
                          }
                        />
                      </>
                    )}
                  </Col>
                </Row>
                <TextArea
                  label="Reason For Visit"
                  name="reason_for_visit"
                  placeholder="Please write a brief summary of Patient's reason for visit if any"
                />
                <SelectDate name="date" setFieldValue={setFieldValue} values={values} />{" "}
                <TextArea
                  label=""
                  name="patient_availability_notes"
                  placeholder="Include any additional time or date range details here"
                />
                <Select label="Patient Preferred Contact Method" name="preferred_contact_method">
                  <option>{"Select patient preferred contact method"}</option>
                  <option value="text">{"Text"}</option>
                  <option value="phone">{"Phone"}</option>
                </Select>
                <Checkbox
                  name="patient_booking_availability"
                  children={
                    <>
                      Patient is available for booking within next 30 minutes
                      <br />
                      <small id="from">
                        If patient is unavailable, please provide availability details in the notes
                        section
                      </small>
                    </>
                  }
                />
                <TextArea label="Notes" name="notes" placeholder="Write additional notes" />
                <button id="btn outline" type="submit">
                  Submit Appointment Request
                </button>
              </Form>
            );
          }
          return (
            <Col
              className="appointment "
              id="requested"
              lg={
                appointment.appointment_request_status == "visit_status_check" ||
                appointment.appointment_request_status == "appointment_completed" ||
                appointment.appointment_request_status == "appointment_not_completed"
                  ? 4
                  : appointment.appointment_request_status == "appointment_request_created" &&
                    !taskValues.editing.scheduled
                  ? 12
                  : 6
              }
              md={12}
              sm={12}
            >
              {taskValues.editing.requested && renderEditRequestForm()}
              {!taskValues.editing.requested && (
                <>
                  <Lead message={"Appointment Request"} />
                  <br />
                  <BsCalendarPlus id="appointment-big-icon" /> <br />
                  <label>{"Visit Type"} </label>
                  {values.procedure_type && values.procedure_type}
                  <label>{"Requested Provider"}</label>{" "}
                  {values.procedure_type == "Lab/Diagnostic Only"
                    ? "N/A for Lab/Diagnostic Only"
                    : (values.pcp || "Any Available Provider")}
                  {values.pcp_practice_id && (
                    <>
                      <label>Location</label>
                      <MdPlace className="pcp-icon" />
                      {values.pcp_practice_name}
                      <br />
                      {values.pcp_practice_address}
                    </>
                  )}
                  <label>{"Patient Status "}</label>
                  {values.established ? "Patient is established" : "Patient is new to PCP Group"}
                  {values.reason_for_visit && (
                    <>
                      <label>{"Reason for Visit"} </label>
                      {values.reason_for_visit && values.reason_for_visit}
                    </>
                  )}
                  {values.request_date_start && !values.request_date_end && (
                    <>
                      {" "}
                      <label> {"Requested Date"}</label>
                      {"Patient has a specific date request for "}{" "}
                      <b> {values.request_date_start}</b>
                    </>
                  )}
                  {values.request_date_start && values.request_date_end && (
                    <>
                      {" "}
                      <label> {"Requested Dates"}</label>
                      {"Patient will take any appointment within the following range "}
                      <b>{values.request_date_start}</b>
                      {" to "}
                      <b>{values.request_date_end}</b>
                    </>
                  )}
                  {!values.request_date_start &&
                    !values.request_date_end &&
                    values.patient_availability_notes && (
                      <>
                        <label> {"Requested Dates"}</label>
                        {"Patient will take any appointment within the following range "}
                        {values.patient_availability_notes}
                      </>
                    )}
                  {values.preferred_contact_method && (
                    <>
                      <label>{"Patient Preferred Contact Method"}</label>
                      {values.preferred_contact_method.charAt(0).toUpperCase() +
                        values.preferred_contact_method.slice(1)}
                    </>
                  )}
                  <br />
                  {values.notes && (
                    <>
                      <label>{"Notes "} </label>
                      {values.notes}
                    </>
                  )}
                  <br />
                  {values.patient_booking_availability ? (
                    <>
                      {" "}
                      <MdCheckCircle className="outcome-icon primary-accent" />
                      Patient is available for booking in the next 30 minutes
                    </>
                  ) : (
                    <>
                      <MdCancel className="outcome-icon error" />
                      Patient is NOT available for booking in the next 30 minutes.
                    </>
                  )}
                  <span className="bottom-right mt10" id="from">
                    {new Date(appointment.created_at).toLocaleString([], {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </>
              )}
            </Col>
          );
        }}
      </Formik>
    </>
  );
};

export default Request;
